import {
  BoxProps,
  EditableInputProps,
  EditablePreviewProps,
  EditableProps,
  FlexProps,
} from '@chakra-ui/react';

export const containerStyles: EditableProps = {
  color: 'primary.700',
  fontSize: '3xl',
  fontWeight: 'medium',
  width: 'full',
};

export const componentWrapperStyles: FlexProps = {
  alignItems: 'center',
  maxWidth: '100%',
  _hover: {
    '.field-icon': {
      opacity: 1,
    },
  },
};

export const componentPreviewStyles: EditablePreviewProps = {
  maxWidth: '100%',
  isTruncated: true,
};

export const componentInputStyles: EditableInputProps = {
  _focusVisible: {
    boxShadow: 'none',
  },
};

export const componentBoxStyles: BoxProps = {
  as: 'span',
  className: 'field-icon',
  marginLeft: 2,
  transition: 'opacity 0.2s',
};
